import { RootState } from '@/app/model/store';

export const selectEntities = (state: RootState) => state.encounter.byId;

export const selectEncounterById =
  (encounterId: string | undefined) => (state: RootState) =>
    encounterId ? selectEntities(state)[encounterId] : undefined;
